import firebase from 'firebase';

const firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyClA2kfmtsX3bVxD98hJFMStoBJoziGQM8",
    authDomain: "shopperapp-f4872.firebaseapp.com",
    projectId: "shopperapp-f4872",
    storageBucket: "shopperapp-f4872.appspot.com",
    messagingSenderId: "756477864975",
    appId: "1:756477864975:web:ae61daece4f2477e51c77a"
  });

const db = firebaseApp.firestore();
const auth = firebase.auth();
const storage = firebase.storage();

export {db, auth, storage};